import React from "react";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddPolPod() {
  const history = useHistory();
  const classes = useStyles();

  const [countryData, setCountryData] = useState([]);

  const [country, setCountry] = useState("");
  const EmpId = localStorage.getItem("EmpId");

  const SelectCountry = (event) => {
    setCountry(event.target.value);
  };

  const FetchCountry = async () => {
    try {
      const data = await api.get("api/master/country");
      setCountryData(data.data.data);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    FetchCountry();
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ท่าเรือ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              POL/POD
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / POL/POD
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            pol_name: "",
            pol_no: "",
            country_id: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.pol_name || values.pol_name === "") {
              errors.pol_name = " * Required";
            }
           
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                no: values.pol_no,
                name: values.pol_name,
                countryId: country,
                status: 1,
                createId: EmpId,
              };

              api
                .post("/api/polpod/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มท่าเรือสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/PolPod");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });
              // alert(JSON.stringify(data, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มท่าเรือ
              </h6>
              <Grid container>
                <Grid item xs={12}>
                  <TextField
                    name="pol_name"
                    label="POL"
                    variant="outlined"
                    placeholder="POL"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.pol_name}
                    classes={{ root: !values.pol_name ? classes.customOutline : null }}
                      required
                  />
                  </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="pol_no"
                    label="code"
                    variant="outlined"
                    placeholder="Code"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.pol_no}
                    classes={{ root: !values.pol_no ? classes.customOutline : null }}
                      required
                  />
                  </Grid>
                  {/* {errors.pol_name && touched.pol_name && errors.pol_name} */}
                  <Grid item xs={12}>
                    <FormControl fullWidth  classes={{ root: !country ? classes.customOutline : null }}
                      required>
                      <InputLabel sx={{top:'10px', }}>Country</InputLabel>
                      <Select
                        value={country ? country : ""}
                        onChange={SelectCountry}
                        label="Country *"
                        style={{
                          width: "50%",
                          marginTop: "10px",
                          marginBottom:'10px'
                        }}
                      >
                        {countryData.map((option) => {
                          return (
                            <MenuItem
                              key={option.CountryId}
                              value={option.CountryId}
                            >
                              {option.CountryName}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* <TextField
                    label="POL  NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter POL  NO."
                    name="pol_no"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.pol_no}
                  />
                  {errors.pol_no && touched.pol_no && errors.pol_no} */}
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
